import { ComponentStyleConfig } from '@chakra-ui/react';

export const Container: ComponentStyleConfig = {
    sizes: {
        'site-content': {
            maxW: '112.5rem'
        }
    }
};
